module.exports = __webpack_public_path__ + "img/bannerdl2.e38a1858.png";